export const parseDateString = (str: string) => {
  const date = new Date(str)
  const day = date.getDate()
  const month =
    date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  const dayMount = [day, month].join('.')

  const time = date.toLocaleTimeString()

  const result = [dayMount, time].join(' ')
  return result
}
